if (!customElements.get('price-slider')) {
  class PriceSlider extends HTMLElement {
    constructor() {
      super();
      this.firstRun = true;
      this.updateTimeout = null;
      this.previousMinValue = null;
      this.previousMaxValue = null;
      this.init();
    }

    init() {
      this.priceSlider = this.querySelector('#price-slider');
      this.priceRangeComponent = this.parentElement?.querySelector('price-range');
      this.filterMaxText = this.querySelector('[filter-max-text]');
      this.filterMinText = this.querySelector('[filter-min-text]');
      if (!this.priceRangeComponent) {
        console.error("Price range component not found");
        return;
      }

      this.minInput = this.priceRangeComponent.querySelector('[name="filter.v.price.gte"]');
      this.maxInput = this.priceRangeComponent.querySelector('[name="filter.v.price.lte"]');

      if (!this.minInput || !this.maxInput) {
        console.error("Min or Max input elements not found");
        return;
      }

      this.previousMinValue = this.minInput.value;
      this.previousMaxValue = this.maxInput.value;

      this.initSlider();
    }

    initSlider() {
      if (this.priceSlider.noUiSlider) {
        this.priceSlider.noUiSlider.destroy();
      }

      const currentMinValue = Number(this.minInput.value?.replace(/,/g, '')) || 0;
      const currentMaxValue = Number(this.maxInput.value?.replace(/,/g, ''));
      this.minValue = Number(this.minInput.dataset.min?.replace(/,/g, '')) || 0;
      this.maxValue = Number(this.maxInput.dataset.max?.replace(/,/g, ''));


      noUiSlider.create(this.priceSlider, {
        start: [currentMinValue, currentMaxValue],
        connect: true,
        range: {
          'min': this.minValue,
          'max': this.maxValue,
        },
        step: 1,
        tooltips: false,
      });
      // return;
      this.priceSlider.noUiSlider.on('update', (values) => {
        if (this.firstRun) {
          this.firstRun = false;
          return;
        }
        if (this.filterMaxText && this.filterMinText) {
          this.filterMinText.textContent = window.accessibilityStrings.currenySymbol + values[0];
          this.filterMaxText.textContent = window.accessibilityStrings.currenySymbol + values[1];
        }
        
        clearTimeout(this.updateTimeout);
        this.updateTimeout = setTimeout(() => {
          const formattedMinInput = parseFloat(this.minInput.value.replace(/,/g, '')) || this.minValue;
          const formattedMaxInput = parseFloat(this.maxInput.value.replace(/,/g, '')) || this.maxValue;
          const formattedValuesMin = parseFloat(values[0].replace(/,/g, ''));
          const formattedValuesMax = parseFloat(values[1].replace(/,/g, ''));
          if (formattedMinInput !== formattedValuesMin || formattedMaxInput !== formattedValuesMax) {
            const newMinValue = values[0];
            const newMaxValue = values[1];
            let changedInput = null;

            if (newMinValue !== this.previousMinValue) {
              changedInput = this.minInput;
              this.previousMinValue = newMinValue;
            } else if (newMaxValue !== this.previousMaxValue) {
              changedInput = this.maxInput;
              this.previousMaxValue = newMaxValue;
            }

            this.minInput.value = newMinValue;
            this.maxInput.value = newMaxValue;

            if (changedInput) {
              const form = changedInput.closest('form');
              const formData = new FormData(form);
              new URLSearchParams(formData).toString();
              this.FiltersPram = new URLSearchParams(formData).toString();
              this.toggleLoading();
              this.updateUrl();
              // const customEvent = new CustomEvent('priceFilter', { detail: { input: changedInput } });
              // console.log(this.closest('facet-filters-form'));
              // this.closest('facet-filters-form').dispatchEvent(customEvent);
            }
          }
        }, 500);
      });
    }


    toggleLoading() {
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainer) { countContainer.classList.add('loading'); }
      if (countContainerDesktop) { countContainerDesktop.classList.add('loading'); }
      // 
      const drawerEl = document.querySelector('.mobile-facets__disclosure');
      if (drawerEl && drawerEl.classList.contains('menu-opening')) {
        drawerEl.classList.remove('menu-opening');
        if (document.body.classList.contains('overflow-hidden-mobile')) { 
          document.body.classList.remove('overflow-hidden-mobile');
        }
        setTimeout(() => {
          drawerEl.removeAttribute('open');
        }, 1000);
      }
    }

    updateUrl() {
      const collectionHandle = window.location.pathname.split('/').pop();
      let updatedUrl = `${collectionHandle}?${this.FiltersPram}`;
      window.history.replaceState({}, '', updatedUrl);
      this.fetchProducts();
    }
    async fetchProducts() {
      const apiUrl = `${this.dataset.url}&${this.FiltersPram}`;
      try {
        const response = await fetch(apiUrl);
        const text = await response.json();
        const firstKey = Object.keys(text)[0];
        const htmlString = text[firstKey];
        const parser = new DOMParser();
        const textDoc = parser.parseFromString(htmlString, 'text/html');

        this.sectionIdSectionSource = textDoc?.querySelector(`#shopify-section-${this.dataset.section}`);
        this.sectionIdSection = document.querySelector(`#shopify-section-${this.dataset.section}`);
        setTimeout(() => {
          this.sectionIdSection.outerHTML = this.sectionIdSectionSource.outerHTML;
        }, 100);
      }
      catch (error) {
        console.error('Error fetching products:', error);
        alert('There was an error fetching products. Please try again.');
        location.reload();
      }
    }
  }
  customElements.define('price-slider', PriceSlider);
}
